import React, { useEffect, useState } from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import Loader from "../common/Loader";
import { Notification } from "../notification/Notification";
import { useSelector } from "react-redux";

const GET_NOTIFICATIONS = gql`
  query notifications {
    notifications {
      id
      type
      content
      date
      read
      resource_id
      details
      author {
        id
        firstname
        lastname
        profile_media {
          url
        }
      }
    }
  }
`;
const MARK_ALL_NOTIFICATIONS_AS_READ = gql`
  mutation mark_all_notifications_as_read {
    mark_all_notifications_as_read
  }
`;
const NavbarNotifications = ({ className }) => {
  const [opened, setOpened] = useState(false);
  const user = useSelector((state) => state.user);
  const { loading, data, refetch } = useQuery(GET_NOTIFICATIONS, {
    skip: !user,
  });
  const unreadNotifications = data?.notifications?.filter(
    (notification) => !notification.read
  ).length;

  const [markAllNotificationsAsRead] = useMutation(
    MARK_ALL_NOTIFICATIONS_AS_READ
  );

  useEffect(() => {
    const interval = setInterval(refetch, 30000);
    return () => {
      clearInterval(interval);
    };
  }, [refetch]);
  return (
    <div className={`dropdown  dropdown-notifications ${className}`}>
      <div
        style={{ position: "relative" }}
        className="nav-link dropdown-toggle"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        onClick={async () => {
          setOpened(!opened);
          if (opened && unreadNotifications > 0) {
            await markAllNotificationsAsRead();
            refetch();
          }
        }}
      >
        <i
          className={`fa-${opened ? "solid" : "regular"} fa-bell text-white`}
          style={{ fontSize: "1.2rem" }}
        ></i>
        {unreadNotifications > 0 && (
          <span
            className="badge bg-danger p-1"
            style={{
              fontSize: "0.7rem",
              top: "-5px",
              position: "absolute",
              left: "14px",
            }}
          >
            {unreadNotifications}
          </span>
        )}
      </div>

      <div className="dropdown-menu dropdown-menu-end" data-bs-theme="light">
        {loading && <Loader />}
        {!loading &&
          data?.notifications?.length > 0 &&
          data.notifications.map((notification, index) => (
            <React.Fragment key={notification.id}>
              <Notification notification={notification} onRead={refetch} />
              {index < data.notifications.length - 1 && <hr className="m-0" />}
            </React.Fragment>
          ))}
        {!loading && data?.notifications?.length === 0 && (
          <div className="p-2 py-3 text-center text-muted">
            Vous n'avez pas de notifications
          </div>
        )}
      </div>
    </div>
  );
};

export default NavbarNotifications;
